// extracted by mini-css-extract-plugin
export var orderDetails = "_u4-2";
export var orderImage = "_u4-1";
export var orderMeta = "_u4-3";
export var orderSummary = "_u4-0";
export var rightArrow = "_u4-4";